import React from "react"

import { Paper, type PaperProps } from "@mui/material"
import type { SxProps, Theme } from "@mui/material/styles"

interface PageFilterCardProps extends PaperProps {
  children: React.ReactNode
}

export const PageFilterCard: React.FC<PageFilterCardProps> = ({
  children,
  sx,
  ...rest
}) => (
  <Paper
    {...rest}
    sx={
      [
        {
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          px: 3,
          py: 2,
        },
        sx,
      ] as SxProps<Theme>
    }
  >
    {children}
  </Paper>
)
